import Item, { SHIFT_UP_DESKTOP, SHIFT_UP_MOBILE } from './Item';
import { SIZE_GROUND } from './Item';
import { NIGHT_TINT } from 'app/constants/AppConstants.js';
import { TAP_LIMIT } from '../../../constants/AppConstants';

const STATE_CLOSED = 1;
const STATE_OPENING = 2;
const STATE_OPEN = 3;
const STATE_CLOSING = 4;

export default class Book extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });
    this.loadTexture('empty');

    this.state = STATE_CLOSED;

    this.hitArea = new Phaser.Rectangle(-50, -65, 100, 65);
    this.bbArea = new Phaser.Rectangle(-50, -65, 100, 65);

    this.asset = this.game.make.spine(0, -40, 'spine_' + this.id, true);
    this.asset.anchor.set(0.5, 1);
    this.addChild(this.asset);

    this.rootBone = this.asset.skeleton.getRootBone();
    this.setScale(SIZE_GROUND);

    this.asset.setAnimationByName(0, '01_closed', false);
  }

  get height() {
    return 65;
  }

  setScale(scale) {
    if (this.rootBone) {
      this.rootBone.scaleX = this.rootBone.scaleY = scale;
    }
  }

  updateBounds() {
    if (this.visible) {
      this.updateTransform();
      this.bbArea.x = this.worldPosition.x - this.bbArea.width * 0.5;
      this.bbArea.y = this.worldPosition.y - this.bbArea.height;
      this.bb = this.bbArea;
    } else {
      this.bb = this.emptyBB;
    }
  }

  setLight(power) {
    // console.log('set light:', power);
    const r0 = 1;
    const g0 = 1;
    const b0 = 1;

    const tint = NIGHT_TINT;
    const r1 = (tint >> 16) / 255;
    const g1 = ((tint >> 8) & 0x00ff) / 255;
    const b1 = (tint & 0x0000ff) / 255;

    this.asset.skeleton.color.r = r1 + power * (r0 - r1);
    this.asset.skeleton.color.g = g1 + power * (g0 - g1);
    this.asset.skeleton.color.b = b1 + power * (b0 - b1);
  }

  changeState() {
    this.state++;
    this.state = this.state === 5 ? 1 : this.state;

    switch (this.state) {
      case STATE_CLOSED:
        this.asset.setAnimationByName(0, '01_closed', false);
        break;
      case STATE_OPENING:
        this.asset.setAnimationByName(0, '02_opening', false);
        this.asset.onComplete.addOnce(this.changeState, this);
        break;
      case STATE_OPEN:
        this.hitArea = new Phaser.Rectangle(-85, -65, 170, 65);
        this.asset.setAnimationByName(0, '03_open', false);
        break;
      case STATE_CLOSING:
        this.hitArea = new Phaser.Rectangle(-50, -65, 100, 65);
        this.asset.setAnimationByName(0, '04_closing', false);
        this.asset.onComplete.addOnce(this.changeState, this);
        break;
    }
  }

  canStack(stackType) {
    if (this.state === STATE_CLOSED) {
      return super.canStack(stackType);
    }
    return false;
  }

  handleInputUp() {
    this.location.stopDragItem(this);
    this.drag = false;
    this.updateBounds();

    this.setScale(SIZE_GROUND);

    // check if it was moved
    const dx = this.pointer.x - this.startPos.x;
    const dy = this.pointer.y - this.startPos.y;
    const dist = dx * dx + dy * dy;

    this.pointer = null;

    if (dist < TAP_LIMIT && this.game.deviceMetric.platform.type !== 'desktop') {
      // fix position
      const dy =
        this.game.deviceMetric.platform.type === 'desktop' ? SHIFT_UP_DESKTOP : SHIFT_UP_MOBILE;
      this.y -= dy;

      this.changeState();
    }
    // drop item
    this.onDrop.dispatch(this);
  }

  handleTap() {
    this.changeState();
  }

  canHover() {
    return !this.drag;
  }

  update() {
    this.asset.update();
    super.update();
  }

  pulse(time = 1500) {
    const s0 = 0.8;
    const s1 = 1.3;
    const tween1 = this.game.add
      .tween(this.rootBone)
      .to({ scaleX: [s1, s0, s1, s0, s1, s0, 1], scaleY: [s0, s1, s0, s1, s0, s1, 1] }, time, null);
    const tween2 = this.game.add
      .tween(this.rootBone)
      .to(
        { scaleX: [s1, s0, s1, s0, s1, s0, 1], scaleY: [s0, s1, s0, s1, s0, s1, 1] },
        time,
        null,
        false,
        200
      );
    tween1.chain(tween2);
    tween1.start();
  }
}
